/**
 * Reads the Firebase custom token the partner app passes as `?authToken=`
 * and removes it from the address bar right away.
 *
 * The token is a bearer credential, so it must not stay in `location.href`,
 * where Sentry, Segment, Intercom and the router would pick it up. This module
 * has no imports and is imported first in `src/index.tsx`, so it runs before
 * the router is created and before any telemetry is initialised.
 */
const url = new URL(window.location.href);

export const authToken = url.searchParams.get("authToken");

if (url.searchParams.has("authToken")) {
    url.searchParams.delete("authToken");
    window.history.replaceState(window.history.state, "", url.href);
}
